import { render, staticRenderFns } from "./NumPrizeView.vue?vue&type=template&id=39b8741e&scoped=true"
import script from "./NumPrizeView.vue?vue&type=script&lang=js"
export * from "./NumPrizeView.vue?vue&type=script&lang=js"
import style0 from "./NumPrizeView.vue?vue&type=style&index=0&id=39b8741e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b8741e",
  null
  
)

export default component.exports